import React, { ReactElement, useCallback, useMemo, useState } from 'react';

import { useMobileDetector } from '../../../../../hooks';
import { TeamMembers } from '../../../../../pages/about';
import { GhostButton } from '../../../../button';
import MaxWidth from '../../../../shared/MaxWidth';
import { Profile } from '../../../../shared/profile';
import { MEMBERS_IN_COLLAPSED_STATE } from '../../constants';
import * as S from './Team.styles';

type Props = {
  teamMembers: TeamMembers;
};
export const Team = (props: Props): ReactElement => {
  const { teamMembers: { items: employees } } = props;

  const { isMobile } = useMobileDetector();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const members = useMemo(
    () =>
      employees.slice(0, isCollapsed && isMobile ? MEMBERS_IN_COLLAPSED_STATE : employees.length),
    [isMobile, isCollapsed, employees],
  );

  const toggleCollapsedState = useCallback(() => {
    setIsCollapsed(!isCollapsed);
  }, [isCollapsed, setIsCollapsed]);

  return (
    <MaxWidth>
      <S.Wrapper>
        <S.SubCaption>our team</S.SubCaption>
        <S.Caption>Meet the brain trust</S.Caption>
        <S.ContentBlock>
          {members.map(({ fields: { name, position, image }}) => (
            <Profile
              key={name}
              img={{ url: `https:${image.fields.file.url}`, alt: name }}
              name={name}
              position={position}
            />
          ))}
        </S.ContentBlock>
      </S.Wrapper>
      {isMobile && (
        <S.ViewSwitcher>
          <GhostButton
            analyticsEvent={{ category: 'About Us: Team', action: 'Toggle View' }}
            onClick={toggleCollapsedState}
          >
            {isCollapsed ? 'Show more' : 'Show less'}
          </GhostButton>
        </S.ViewSwitcher>
      )}
    </MaxWidth>
  );
};
